import { useUser } from '@/contexts/UserContext/UserContext';

/**
 * Safe hook to access user data that handles Context initialization errors
 * This prevents any context errors during app bootstrap
 */
function useSafeUser() {
  try {
    const { user } = useUser();
    return user;
  } catch {
    // Handle any context initialization errors gracefully
    return null;
  }
}

export default useSafeUser;
